// Lifecycle decision renderer.
//
// `continue` / `augment` render inline; `block` delegates to `BlockNotice`
// because phase 10a's gate outcomes carry structured `hints` (missing DoR /
// DoD fields, optional rubric verdicts) that need their own layout.

import type { GateBlockHints } from "@loom/shared";

import { useT } from "../../i18n/index.js";

import { BlockNotice } from "./BlockNotice";

interface LifecycleNoticeProps {
  readonly phase: string;
  readonly handler: string;
  readonly outcome:
    | { readonly kind: "continue" }
    | { readonly kind: "augment"; readonly systemNote: string }
    | {
        readonly kind: "block";
        readonly reason: string;
        readonly hints?: GateBlockHints;
      };
}

export function LifecycleNotice({ handler, outcome, phase }: LifecycleNoticeProps) {
  const t = useT();
  if (outcome.kind === "continue") {
    return (
      <div className="text-[11px] text-ink-subtle">
        <span className="font-mono">{handler}</span> @ {phase}: {t("chatRender.lifecycleContinue")}
      </div>
    );
  }
  if (outcome.kind === "augment") {
    return (
      <div className="rounded-md border border-info-line bg-info-soft p-2 text-xs text-info-fg-3">
        <span className="font-mono">{handler}</span>: {outcome.systemNote}
      </div>
    );
  }
  return (
    <BlockNotice
      handler={handler}
      reason={outcome.reason}
      {...(outcome.hints !== undefined ? { hints: outcome.hints } : {})}
    />
  );
}
